module.exports = __webpack_public_path__ + "static/media/Catherine Escoto.4a6d8090.png";